const clientBaseurl='https://local.moneyds.cn:13745';
const tasking = clientBaseurl+'/taskProceed';
const appinfourl=clientBaseurl+'/getappinfo'; // 获取助手信息
const clientloginurl=clientBaseurl+'/login1'; // 登录接口
const loginfromurl=clientBaseurl+'/successloginwanpan';
const allapps=clientBaseurl+'/allapps';
const v2deviceinfo=clientBaseurl+'/v2deviceinfo';
const ios11openurl=clientBaseurl+'/ios11StartTaskByOpenAppWithBundleId';
const fastDetailOpenurl = clientBaseurl+'/fastDetailOpenurl';              //快速任务详情页，打开
const dianrulisturl=clientBaseurl+'/v2drapilist';
const dianruclick = clientBaseurl+"/v2drapiclick";
const v2drnulltask = clientBaseurl+"/v2drnulltask";
const v2drinstallapp = clientBaseurl+"/v2drinstallapp";
const v2dropentime = clientBaseurl+"/v2dropentime"; 
const v2drapicallback = clientBaseurl+"/v2drapicallback";
const v3ispurRedownWithid=clientBaseurl+'/v3ispurRedownWithid';
const v4ispurRedownWithid=clientBaseurl+'/v4ispurRedownWithid';
const wanpuredirecturl='LongFlower://lianmeng_sdk_open_action?';
const wanpufastlisturl=clientBaseurl+'/lc_async_notification/v3WPTaskWallListData';
const V4installapp = clientBaseurl + '/V4installapp';       //IOS12一下检测是否安装
const v2pasteboard=clientBaseurl+'/v2pasteboard';
const localpush=clientBaseurl+'/localpush';
const v2cattrystarttask=clientBaseurl+'/v2cattrystarttask';
const pushTelController=clientBaseurl+'/pushTelController';
const findoriginaccount=clientBaseurl+'/findoriginaccount';
const rewardRecord=clientBaseurl+'/reloadTask';
const postInfoToServer = clientBaseurl +'/postInfoToServer';
const v4clickstorefora = clientBaseurl +'/v4clickstorefora'; //A类用户自动打开应用相关
const v4giveuptaskfora = clientBaseurl +'/v4giveuptaskfora'; //A类用户放弃任务相关
const v4autopriceresultfora = clientBaseurl +'/v4autopriceresultfora'; //A类用户领奖过后
const getIphoneAddress = clientBaseurl +'/getIphoneAddress'; //获取用户的位置信息
const v4gotosetting = clientBaseurl +'/v4gotosetting'; //去设置地理位置
const v4priceloop = clientBaseurl +'/v4priceloop'; // 自动领奖（无自动打开）
const getopenapptime = clientBaseurl +'/getopenapptime'; // 打开应用时间倒计时（3分钟）
const v2cattryfinishtask = clientBaseurl + '/v2cattryfinishtask'; // 快速任务领奖
const installapp = clientBaseurl + '/installapp'; // iOS10及以下检测App是否存在（boundID列表）

export default{
    installapp,
    v2cattryfinishtask,
    getopenapptime,
    v4priceloop,
    v4gotosetting,
    getIphoneAddress,
    v4autopriceresultfora,
    v4clickstorefora,
    v4giveuptaskfora,
    tasking,
    clientBaseurl,
    appinfourl,
    clientloginurl,
    loginfromurl,
    allapps,
    v2deviceinfo,
    dianrulisturl,
    dianruclick,
    v2drinstallapp,
    v2drnulltask,
    v2dropentime,
    v2drapicallback,
    wanpufastlisturl,
    wanpuredirecturl,
    ios11openurl,
    fastDetailOpenurl,
    v3ispurRedownWithid,
    v4ispurRedownWithid,
    installapp,
    v2pasteboard,
    localpush,
    v2cattrystarttask,
    pushTelController,
    findoriginaccount,
    rewardRecord,
    V4installapp,
    postInfoToServer
}
